import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import Helper from '../../common/Helper';
import AppDataContext from '../../common/AppContext';

const useStyles = makeStyles((theme) => ({
    chip: {
        fontSize: '.63rem',
        letterSpacing: '0.0500em',
        color: '#8f8f8f',
        borderColor: '#8f8f8f',
        margin: theme.spacing(.5, 0, .5, 0),
        textTransform: 'uppercase',
        padding: theme.spacing(0, .5, 0, .5),
    },
}));

const PreviewShopIcon = (props) => {   
    const classes = useStyles();
    const { leagueName } = useContext(AppDataContext);

    const navigateToStore = (e) => {
        if (!props.teamName) {
            return;
        }
        Helper.OpenShopLink(props.teamName)
    }

    return (
        <Chip
            id={props.teamName}
            clickable
            label="Shop"
            onClick={navigateToStore}
            onDelete={navigateToStore}
            deleteIcon={<AddShoppingCartIcon style={{ fontSize: 12, color: "#8f8f8f" }} />}
            variant="outlined"
            color="primary"
            className={classes.chip}
            data-gaeventname="shop_click"
            data-gaeventcategory={`${props.teamName} Shop`}
            data-gaeventlabel={`${props.teamName} ${leagueName} Store`}
            data-gaeventaction={`${Helper.getShopUrl(props.teamName)}`}            
        />
    )
}

export default PreviewShopIcon;